/**
 * In the browser, prefer same-origin relative requests so Vite's dev proxy handles
 * routing, CORS, and large auth headers. Direct `localhost:9016` calls from
 * `localhost:8082` are cross-origin and commonly fail with 401/CORS.
 *
 * When `VITE_*_BASE_URL` is set to `http://localhost:901x` in `.env.local`, the
 * browser must still call `/record-service` / `/document-service` on the dev-server
 * origin (8082) — see `vite.config.ts` proxy table.
 */
export const resolveServiceBaseUrl = (configuredBaseUrl: string): string => {
  if (!configuredBaseUrl) {
    return "";
  }

  if (typeof window === "undefined") {
    return configuredBaseUrl;
  }

  // Local `npm run dev`: always proxy via Vite (same origin as the SPA).
  if (import.meta.env.DEV) {
    return "";
  }

  try {
    const configured = new URL(configuredBaseUrl);
    if (configured.origin !== window.location.origin) {
      return "";
    }
  } catch {
    return configuredBaseUrl;
  }

  return configuredBaseUrl;
};
